/**
 * 司法法官
 */
const App = () => import('@/module/index/layout/App.vue')
const judgesIndex = () => import('@/module/index/pages/judges/index.vue')
const judgesDetail = () => import('@/module/index/pages/judges/detail.vue')

export default {
  path: '/judges',
  component: App,
  redirect: '/judges/index',

  children: [{
    path: '/judges/index',
    component: judgesIndex
  },
  {
    path: '/judges/index/:id',
    component: judgesDetail
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/judges.js